
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.css',
  standalone:false
})
export class ErrorComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, message: string}, private dialogRef: MatDialogRef<ErrorComponent>) { }
  
  cancel(){
    this.dialogRef.close(false);
  }

  confirm(){
    this.dialogRef.close(false);
  }
}
 
